import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "是否異常",
    isNumber: true,
  },
];

export const Table = {
  label: "各項需追蹤人數_表格",
  key: "Table",
  path: "HealthAnalysisManagement/Table",
  api: "TCS_V_EyesS01",
  render: (options) => <Diagram.HealthAnalysisManagement.Table {...options} />,
  // isColSum: true,
  // isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "CaseStatus",
      field: "CaseStatus",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
